import sanitizeHTML from 'sanitize-html';

/**
 * The tags and attributes the article reader shows. Everything else, event
 * handlers and javascript: links included, is removed. Only the article reader
 * uses it: it keeps `class` on `div` and `nav` for the reader's own markup
 * (`<nav class="toc">`). For HTML fragments from a scraped page, from the model
 * or from a Firestore document a client can write, use sanitizeFragmentHtml.
 */
const ARTICLE_HTML_OPTIONS: sanitizeHTML.IOptions = {
    allowedTags: sanitizeHTML.defaults.allowedTags.concat(['title', 'article', 'nav', 'section']),
    allowedAttributes: {
        ...sanitizeHTML.defaults.allowedAttributes,
        h1: ['id', 'itemprop'],
        h2: ['id'],
        h3: ['id'],
        h4: ['id'],
        h5: ['id'],
        h6: ['id'],
        article: ['itemscope', 'itemtype'],
        p: ['itemprop'],
        div: ['itemprop', 'class'],
        nav: ['class'],
        a: ['href'],
    },
};

export function sanitizeArticleHtml(html: unknown): string {
    if (typeof html !== 'string' || !html) {
        return '';
    }
    return sanitizeHTML(html, ARTICLE_HTML_OPTIONS);
}

/**
 * Stricter variant for HTML fragments the model writes: block proposals (the
 * original, the proposal and the rejected body) and part extensions. Only the
 * sanitize-html default tags, and `href` on links. No `class` and no `id`, so
 * model output cannot borrow app styles (a Vuetify `.v-dialog__content` is a
 * fixed full-screen overlay) or collide with app element ids (#30939).
 */
const FRAGMENT_HTML_OPTIONS: sanitizeHTML.IOptions = {
    allowedTags: sanitizeHTML.defaults.allowedTags,
    allowedAttributes: {
        a: ['href'],
    },
};

export function sanitizeFragmentHtml(html: unknown): string {
    if (typeof html !== 'string' || !html) {
        return '';
    }
    return sanitizeHTML(html, FRAGMENT_HTML_OPTIONS);
}
